import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNiacinamideGlyphSecondary from './svgs/NiacinamideGlyphSecondary.js';
import SvgNiacinamideGlyph from './svgs/NiacinamideGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var niacinamideGlyph = (props => useIcon(SvgNiacinamideGlyph, SvgNiacinamideGlyphSecondary, props));

export { niacinamideGlyph as default };
